<template lang="pug">
	.avatar
		img.img-avatar(:src='_image' style="height:100%;object-fit: cover;")
		span.avatar-status.badge-success(v-if="_badge" :class="`badge-${_badge}`")
</template>

<script>
	export default {
		name: 'Avatar',
		props: ['_image','_badge'],
		data: () => ({}),
	}
</script>
